document.addEventListener('DOMContentLoaded', function () {
  // setTimeout(function() {
    // FADE IN
    gsap.utils.toArray('[data-aos="fade-in"]').forEach((element) => {
      let delay = '0';
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: delay,
        duration: 1,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // FADE UP
    gsap.utils.toArray('[data-aos="fade-up"]').forEach((element) => {
      let delay = '0';
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        opacity: 0,
        y: 75,
      },
      {
        opacity: 1,
        y:0,
        delay: delay,
        duration: .6,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // FADE RIGHT
    gsap.utils.toArray('[data-aos="fade-right"]').forEach((element) => {
      let delay = '0';
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        opacity: 0,
        x: -100,
      },
      {
        opacity: 1,
        x:0,
        delay: delay,
        duration: .5,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // FADE LEFT
    gsap.utils.toArray('[data-aos="fade-left"]').forEach((element) => {
      let delay =parseInt(0);
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        opacity: 0,
        x: 100,
      },
      {
        opacity: 1,
        x:0,
        delay: delay,
        duration: .5,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // FALL DOWN
    gsap.utils.toArray('[data-aos="fall-down"]').forEach((element) => {
      let split = element.innerHTML.split("");
      let delay = 0;
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      element.innerHTML = '';

      split.forEach(line => {
        const newSpan = document.createElement("span");
        newSpan.style.display = "inline-block";
        newSpan.innerHTML = line;
        element.appendChild(newSpan);
      })

      for(let child of element.children) {
        if(child.tagName == 'SPAN') {
          gsap.set(child, {scale: 2, opacity: 0})
          gsap.to(child, {
            duration: 0.3,
            opacity: 1,
            delay: delay + 0.1,
            scrollTrigger: {
            trigger: element,
            toggleActions: "restart reverse restart reverse"
            }
          });
          delay = delay + 0.3;
          gsap.to(child, {
            duration: 0.1,
            scale: 1,
            delay: delay,
            scrollTrigger: {
            trigger: element,
            toggleActions: "restart reverse restart reverse"
            }
          });
        }
      }
    });

    // FADE UP LINE BY LINE
    gsap.utils.toArray('[data-aos="fade-up-lines"]').forEach((element) => {
      let split = element.innerHTML.split(/\r?\n|\r|\n/g);
      let delay = 0;
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      element.innerHTML = '';

      split.forEach(line => {
        const newSpan = document.createElement("span");
        newSpan.style.display = 'inline-block';
        newSpan.innerHTML = line;
        element.appendChild(newSpan);
      })

      for(let child of element.children) {
        if(child.tagName == 'SPAN') {
          gsap.fromTo(child, {
              opacity: 0,
              y: 100,
            },
            {
              opacity: 1,
              y:0,
              delay: delay,
              duration: .5,
              scrollTrigger: {
                trigger: element,
                toggleActions: "restart reverse restart reverse"
              }
            }
          );
          delay = delay + 0.1;
        }
      }
    });

    // ZOOM IN
    gsap.utils.toArray('[data-aos="zoom-in"]').forEach((element) => {
      let delay = '0';
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        scale: 0.4,
      },
      {
        scale: 1,
        delay: delay,
        duration: .3,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // ROTATE IN
    gsap.utils.toArray('[data-aos="rotate-in"]').forEach((element) => {
      let delay = '0';
      if(element.hasAttribute('data-aos-delay')) {
        delay = parseFloat(element.getAttribute('data-aos-delay')/1000);
      }
      gsap.fromTo(element, {
        opacity: 0,
        rotation: -720,
        scale: 0,
      },
      {
        opacity: 1,
        rotation: 0,
        scale: 1,
        delay: delay,
        duration: 0.5,
        scrollTrigger: {
          trigger: element,
          toggleActions: "restart reverse restart reverse"
        }
      }
      );
    });

    // NUMBER ANIMATION
    gsap.utils.toArray('[data-aos="number-increase"]').forEach((element) => {
      let targetTemperature = element.innerHTML;
      let currentTemperature;
      const apiKey = 'dee271f7fc85836e15a3a10f9e4ca236';

      navigator.geolocation.getCurrentPosition(async (position) => {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&units=imperial&appid=${apiKey}`);
        if (response.ok) {
          const weather = await response.json();
          currentTemperature = parseInt(weather.main.temp);
          element.innerHTML = currentTemperature;
        } else {
          element.innerHTML = '100';
        }

        gsap.set(element, {textContent: currentTemperature});
        gsap.to(element, {
          textContent: targetTemperature,
          duration: 1,
          delay: 1,
          snap: { textContent: 1 },
          ease: "power1.in",
          scrollTrigger: {
            trigger: element,
            toggleActions: "restart reverse restart reverse"
          }
        });
      });
    });
  // }, 2000);
}, false);